import { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import Icons from "../../myIcon/Icons";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

export default function ServiceDetailGallery() {
    const galleryRef = useRef(null);
    const [inView, setInView] = useState(false);
    const timeoutRef = useRef(null);

    const sliderRef = useRef(null);

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1100,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        // centerMode: true,
        // centerPadding: "0",
        cssEase: "ease",
        responsive: [
            {
                breakpoint: 991,
                settings: { slidesToShow: 3,},
            },
            {
                breakpoint: 767,
                settings: { slidesToShow: 3, },
            },
            {
                breakpoint: 599,
                settings: { slidesToShow: 2, },
            },
        ],
    };

    const CustomArrows = () => (
        <>
            <div className="default-arrowleft" onClick={() => sliderRef.current.slickPrev()}>
                <Icons name="Longarrow_left" />
            </div>
            <div className="default-arrowright" onClick={() => sliderRef.current.slickNext()}>
                <Icons name="Longarrow_right" />
            </div>
        </>
    );


    useEffect(() => {
        let fancybox;

        import("@fancyapps/ui").then((mod) => {
            fancybox = mod.Fancybox;
            fancybox.bind("[data-fancybox='gallery']", {});
        });

        return () => {
            if (fancybox) {
                fancybox.destroy();
            }
        };
    }, []);


    useEffect(() => {
        const handleScroll = () => {
        const el = galleryRef.current;
        if (!el || inView) return;

        const rect = el.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

        if (isVisible) {
            timeoutRef.current = setTimeout(() => {
            setInView(true);
            }, 500); 
        }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); 

        return () => {
        window.removeEventListener("scroll", handleScroll);
        clearTimeout(timeoutRef.current); 
        };
    }, [inView]);

  return (
    <>
    <section className="detailserv-gallery">
        <div className="container">
            <div className="row"> 
                <div className="col-lg-12">
                    <div className="line-heading">
                        <div ref={galleryRef} className={`lineeffect ${inView ? "showline" : ""}`}></div>
                        <span>Gallery</span>
                    </div>
                </div>
            </div>
        </div>

        <div className="gallery-slider">
            <Slider {...settings} ref={sliderRef}>
                <div className="gallery-box">
                    <a href="/image/millwork-gallery-1.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-1.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Viceversa VV06 VV05 Living</p>
                </div>

                <div className="gallery-box">
                    <a href="/image/millwork-gallery-2.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-2.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Lemmy LY03 Home-office</p>
                </div>

                <div className="gallery-box">
                    <a href="/image/millwork-gallery-3.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-3.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Elysian EY03</p>
                </div>

                <div className="gallery-box">
                    <a href="/image/millwork-gallery-4.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-4.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Jewels JW12 Veinmatching</p>
                </div>

                <div className="gallery-box">
                    <a href="/image/millwork-gallery-5.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-5.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Viceversa VV02 Commercial</p>
                </div>

                <div className="gallery-box">
                    <a href="/image/millwork-gallery-6.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-6.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Cosmopolitan CP06 Jewels JW19 Lounge</p>
                </div>



                <div className="gallery-box">
                    <a href="/image/millwork-gallery-7.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-7.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Viceversa VV06 VV05 Living</p>
                </div>

                <div className="gallery-box">
                    <a href="/image/millwork-gallery-8.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-8.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Lemmy LY03 Home-office</p>
                </div>

                <div className="gallery-box">
                    <a href="/image/millwork-gallery-9.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-9.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Elysian EY03</p>
                </div>

                <div className="gallery-box">
                    <a href="/image/millwork-gallery-10.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-10.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Jewels JW12 Veinmatching</p>
                </div>

                <div className="gallery-box">
                    <a href="/image/millwork-gallery-11.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-11.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Viceversa VV02 Commercial</p>
                </div>

                <div className="gallery-box">
                    <a href="/image/millwork-gallery-12.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-12.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Cosmopolitan CP06 Jewels JW19 Lounge</p>
                </div>

                
                <div className="gallery-box">
                    <a href="/image/millwork-gallery-13.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-13.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Cosmopolitan CP06 Jewels JW19 Lounge</p>
                </div>

                
                <div className="gallery-box">
                    <a href="/image/millwork-gallery-14.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-14.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Cosmopolitan CP06 Jewels JW19 Lounge</p>
                </div>

                
                <div className="gallery-box">
                    <a href="/image/millwork-gallery-15.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-15.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Cosmopolitan CP06 Jewels JW19 Lounge</p>
                </div>

                
                <div className="gallery-box">
                    <a href="/image/millwork-gallery-16.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-16.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Cosmopolitan CP06 Jewels JW19 Lounge</p>
                </div>

                
                <div className="gallery-box">
                    <a href="/image/millwork-gallery-17.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-17.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Cosmopolitan CP06 Jewels JW19 Lounge</p>
                </div>

                
                <div className="gallery-box">
                    <a href="/image/millwork-gallery-18.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-18.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Cosmopolitan CP06 Jewels JW19 Lounge</p>
                </div>

                
                <div className="gallery-box">
                    <a href="/image/millwork-gallery-19.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-19.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Cosmopolitan CP06 Jewels JW19 Lounge</p>
                </div>

                
                <div className="gallery-box">
                    <a href="/image/millwork-gallery-20.webp" data-fancybox="gallery">
                        <img src="/image/millwork-gallery-20.webp" className="img-responsive" alt="gallery" loading="lazy" />
                        <span><Icons name="expand" /></span>
                    </a>
                    <p>Cosmopolitan CP06 Jewels JW19 Lounge</p>
                </div>
            </Slider>

            <div className="gallery-arrow">
                <CustomArrows />
            </div>
        </div>
    </section>
    </>
  )
}
